import React from "react";
import "./footer.scss";

import {Link} from "react-router-dom";

const footer = () => {
  return (
    <div className="container-footer">
      <div className="container-atas">
        <div className="container"></div>
        <div className="container-deskripsi">
          <div className="alamat">
            <h1>Marketing Gallery</h1>
            <h2>Summarecon Bogor</h2>
            <h3>Dapatkan Informasi Promo, Brosur dan Pricelist Terbaru</h3>
            <h4>Contact us : +6287874691787 (Heldy)</h4>
            <div className="container-link">
              <Link to="/privacy-policy">
                <div className="footer-contact">Privacy Policy</div>
              </Link>

              <Link to="/termsandcondition">
                <div className="footer-contact">Terms & Condition</div>
              </Link>
            </div>
          </div>
          <div className="privasi"></div>
        </div>
      </div>

      <div className="container-bawah">
        <div className="footer-disclaimer">
          <p className="footer-disclaimer-text">
            Disclaimer : Halaman Informasi Properti Oleh PT Asia Rumah Utama
            diambil Resmi dari Info Properti Summarecon Tangeran. Harga,
            Spesifikasi dan Ketersediaan Unit dapat berubah sewaktu-waktu dan
            Diperlukan Konfirmasi.
          </p>
        </div>
        <div>© Summarecon Bogor</div>
        <div className="footer-poweredby">Powered by PT. Asia Rumah Utama</div>
      </div>
    </div>
  );
};

export default footer;
